module.exports = __webpack_public_path__ + "img/37.f56e4599.jpg";